/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/auto-order-settings';

export const AutoOrderSettingApi = {
  findWithEntity: async () => {
    const url = `${pathname}/entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateAutoOrderSettingBody) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateAutoOrderSettingBody {
  isEnabled?: any;
  isAutoMergeCustomerOrder?: string;
  isAutoCreateOrder?: string;
  type?: boolean;
  minimumOrderQuantity?: number;
  startedAt?: string;
  finishedAt?: string;
  resetTimeAt?: string;
  step?: number;
}

export type AutoOrderSetting = {
  id: string;
  autoOrderMode: number;
  createdAt: string;
  cronjob: string;
  isEnabled: string;
  finishedAt: string;
  resetTimeAt: string;
  month: string[];
  fromOrderStatus: number;
  toOrderStatus: number;
  ownerID: string;
  isReportEnabled: boolean;
  isAutoMergeCustomerOrder: string;
  isAutoCreateOrder: string;
  startedAt: string;
  step: number;
  type: number;
  updatedAt: string;
  week: string[];
};
